/*
 * @Description: 计算字段相关数据存储
 * @Version: 1.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
import { defineStore } from 'pinia';

const useUploadStore = defineStore('upload', {
  state: () => {
    return {
      globalAttachmentInstances: [], //存储附件唯一标识集合
      globalDragActive: false, //拖拽状态
      hoverInstanceId: null, //hover附件唯一标识
      totalPages: 0, // 总页数
      currentPage: 1 // 当前页
    };
  },
  actions: {
    updateInstanceId(updateItem) {
      // 更新实例ID
      this.globalAttachmentInstances.push(updateItem);
    },
    clearInstanceId() {
      // 清除实例ID
      this.globalAttachmentInstances = [];
    },
    clearActive() {
      // 清除所有实例ID的active状态
      this.globalAttachmentInstances.forEach((item) => {
        item.active = false;
      });
    },
    setActive(instanceId) {
      // 设置指定实例ID的active状态为true，其他为false
      this.globalAttachmentInstances.forEach((item) => {
        item.active = item.id == instanceId;
      });
    },
    setGlobalDragActive(status) {
      // 设置全局拖拽状态
      this.globalDragActive = status;
    },

    setHoverInstanceId(id) {
      // 同时清空hover状态
      this.hoverInstanceId = id;
    },
    clearDragState() {
      // 清除拖拽状态
      this.globalDragActive = false;
      this.hoverInstanceId = null;
    },
    setTotalPages(total) {
      // 设置总页数
      this.totalPages = total;
    },
    setCurrentPage(page) {
      // 设置当前页
      this.currentPage = page;
    }
  }
});

export default useUploadStore;
